export enum BootStatus {
    InStock,
    Active,
    PendingReturn
}
